<template>
    <IndexBase @auth="onAuth($event)" action="Index" controller="WoRelease"></IndexBase>
    
    <Card>
        <template #title>
            <Toolbar>
                <template #left>
                    <div class="p-card-title">
                       WO Creation
                    </div>
                </template>
                <template #right>
                    <!-- <Button :label="'Excel'"  icon="pi pi-file-excel"  class="p-button-success p-button-sm" @click="downloadPrint('EXCEL')" /> -->
                </template>
            </Toolbar>
        </template>
        <template #content>
            <DataTable ref="dt" responsiveLayout="scroll" class="p-datatable-sm" filterDisplay="row" sortMode="multiple" removableSort
                stateStorage="local"
                :stateKey="stateKey"
                :value="dataModel" :loading="!dataModel || loading"
                :paginator="true"
                :rows="10"
                :lazy="true"
                v-model:first="this.start"
                @rowExpand="onRowExpand"
                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                :rowsPerPageOptions="[10, 20, 50]" currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                @state-restore="onStateRestore($event)"
                @page="onPage($event)"
                @sort="onSort($event)"
                @filter="onFilter($event)"
                @update:selection="onSelect($event)"
                @row-dblclick="onRowDoubleClick"
                v-model:filters="filters"
                :totalRecords="totalRecords"
                dataKey="Id" :metaKeySelection="false" :rowClass="rowClass" id="main">
                
                <Column :exportable="false" :sortable="false" headerStyle="white-space:nowrap">
                    <template #header>
                        <Button v-show="canCreate" :label="$t('create')" icon="pi pi-plus"
                            class="p-button-primary p-button-sm" @click="editor(this.$FORM_MODE_CREATE, 0)" />
                    </template>
                    <template #filter>
                        <Button :label="$t('clear')" icon="pi pi-filter-slash"
                            class="p-button-outlined p-button-primary p-button-sm" @click="clearFilter" :badge="filterBadge"
                            badgeClass="p-badge-danger" />
                    </template>
                    <template #body="dataModel">
                        <Button icon="pi pi-search" v-show="canView" class="p-button-rounded p-button-info mr-2 p-button-sm" @click="editor(this.$FORM_MODE_VIEW,dataModel.data.Id)" />
                        <Button icon="pi pi-pencil" v-show="canEdit && isEdit(dataModel)"
                            class="p-button-rounded p-button-success mr-2 p-button-sm" @click="editor(this.$FORM_MODE_EDIT, dataModel.data.Id)" />

                        <Button icon="pi pi-pencil" v-show="(dataModel.data.Status == this.$APPROVAL_STATUS.CLOSED && this.$store.getters.getIsUpdateWo)"
                            class="p-button-rounded p-button-success mr-2 p-button-sm" @click="editor(this.$FORM_MODE_UPDATE_STATUS, dataModel.data.Id)" />

                        <Button icon="pi pi-user-plus" v-show="this.$store.getters.getIsUpdateWo"
                            class="p-button-rounded  p-button-icon mr-2 p-button-sm" @click="editorPIC(this.$FORM_MODE_EDIT, dataModel.data.Id)" />
                            
                        <Button icon="pi pi-trash" v-show="canDelete && isDelete(dataModel)"
                            class="p-button-rounded p-button-danger mr-2 p-button-sm" @click="editor(this.$FORM_MODE_DELETE, dataModel.data.Id)" />

                        <Button icon="pi pi-file-pdf p-button-icon" v-show="canPrint && dataModel.data.Is_Deleted == 'N'" class="p-button p-component p-button-icon-only p-button-rounded p-button-danger p-button-outlined mr-2"
                            @click="generatePdf(dataModel.data)"  target="_blank"/>
                    </template>
                </Column>
                
                <!-- <Column field="main_data" :header="$t('main_data')"  class="text-center">
                    <template #body="dataModel">
                        <i class="pi pi-check" style="color: green;width: 70px;" v-if="dataModel.data.main_data == 1 "></i>
                        <i class="pi pi-times" style="color: red;width: 70px;" v-else></i>
                    </template>
                </Column> -->


                <Column field="main_data" :header="$t('main_data')" dataType="date" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <YNSelect :placeholder="$t('main_data')" :useBinary="true" v-if="filterModel" 
                            v-model="filterModel.value" @change="filterCallback()" />
                    </template>
                    <template #body="{ data }">
                         {{ data.main_data == "0" ? "N" : "Y"  }}
                    </template>
                </Column>

                <Column field="Status" :header="$t('status')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('status')" v-if="filterModel"
                            v-model="filterModel.value" @keydown.enter="filterCallback()"
                            class="p-column-filter p-inputtext-sm" />
                    </template>
                    <template #body="{ data }">
                        <span v-if="data.Status == this.$APPROVAL_STATUS.CANCELLED" style="color: red;"> {{ data.Status }} </span>
                        <span v-else > {{ data.Status }} </span>
                    </template>
                </Column>

                <Column field="Wo_Number" :header="$t('no_wo')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('no_wo')" v-if="filterModel"
                            v-model="filterModel.value" @keydown.enter="filterCallback()"
                            class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>
                <Column field="Wo_Number_Main" :header="$t('Link_Main_Wo')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('Link_Main_Wo')" v-if="filterModel"
                            v-model="filterModel.value" @keydown.enter="filterCallback()"
                            class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>   

                <Column field="Rev" :header="$t('rev')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('rev')" v-if="filterModel"
                            v-model="filterModel.value" @keydown.enter="filterCallback()"
                            class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>

                <Column field="is_main" :header="$t('is_main')" dataType="date" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <YNSelect :placeholder="$t('is_main')" :useBinary="true" v-if="filterModel" 
                            v-model="filterModel.value" @change="filterCallback()" />
                    </template>
                    <template #body="{ data }">
                         {{ data.is_main == "0" ? "N" : "Y"  }}
                    </template>
                </Column>
                <Column field="Adopt_SAP" :header="$t('Adopt_SAP')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <YNSelect :placeholder="$t('Adopt_SAP')" :useBinary="true" v-if="filterModel"
                            v-model="filterModel.value" @change="filterCallback()" />
                    </template>
                    <template #body="{ data }">
                        {{ data.Adopt_SAP == true ? "Y" : "N" }}
                    </template>
                </Column>

                <Column field="Department_Code" :header="$t('department')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('department')" v-if="filterModel"
                            v-model="filterModel.value" @keydown.enter="filterCallback()"
                            class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>  

                <Column field="Work_Group" :header="$t('Work_Group')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('Work_Group')" v-if="filterModel"
                            v-model="filterModel.value" @keydown.enter="filterCallback()"
                            class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>   

                <Column field="Work_Description" :header="$t('Work_Description')" :sortable="true" style="white-space: normal;">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('Work_Description')" v-if="filterModel"
                            v-model="filterModel.value" @keydown.enter="filterCallback()"
                            class="p-column-filter p-inputtext-sm" style="width: 350px;"/>
                    </template>
                </Column>   
                
                
                <Column field="Planned_Start_Date" :header="$t('Planned_Start_Date')" dataType="date" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <DatePicker :placeholder="$t('Planned_Start_Date')" dateFormat="dd/mm/yyyy" inputMask="99/99/9999"
                            momentFormat="DD/MM/YYYY" class="p-column-filter p-inputtext-sm" v-if="filterModel"
                            v-model="filterModel.value" @keydown.enter="filterCallback()" @date-select="filterCallback()" />
                    </template>
                    <template #body="{ data }">
                        {{ this.$formatDate(data.Planned_Start_Date) }}
                    </template>
                </Column>
              
                <Column field="Is_Tendering_Completed" :header="$t('Is_Tendering_Completed')" dataType="date" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <YNSelect :placeholder="$t('Is_Tendering_Completed')" :useBinary="true" v-if="filterModel"
                            v-model="filterModel.value" @change="filterCallback()" />
                    </template>
                    <template #body="{ data }">
                         {{ data.Is_Tendering_Completed == "1" ? "Y" : "N" }}
                    </template>
                </Column>

                <Column field="SPO_Item" :header="$t('SPO_Item')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('SPO_Item')" v-if="filterModel"
                            v-model="filterModel.value" @keydown.enter="filterCallback()"
                            class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>   
                <Column field="Information" :header="$t('information')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('information')" v-if="filterModel"
                            v-model="filterModel.value" @keydown.enter="filterCallback()"
                            class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>   


                
                <Column field="Is_Old_Data" :header="$t('Migration_Data')" dataType="date" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <YNSelect :placeholder="$t('Migration_Data')" :useBinary="true" v-if="filterModel"
                            v-model="filterModel.value" @change="filterCallback()" />
                    </template>
                    <template #body="{ data }">
                         {{ data.Is_Old_Data == "0" ? "N" : "Y"  }}
                    </template>
                </Column>
                
                <Column field="Created_Date" :header="$t('created_date')" dataType="date" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <DatePicker :placeholder="$t('created_date')" dateFormat="dd/mm/yyyy" inputMask="99/99/9999"
                            momentFormat="DD/MM/YYYY" class="p-column-filter p-inputtext-sm" v-if="filterModel"
                            v-model="filterModel.value" @keydown.enter="filterCallback()" @date-select="filterCallback()" />
                    </template>
                    <template #body="{ data }">
                        {{ this.$formatDateTime(data.Created_Date) }}
                    </template>
                </Column>
                <Column field="Created_By" :header="$t('created_by')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" v-if="filterModel" v-model="filterModel.value"
                            @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"
                            :placeholder="$t('created_by')" />
                    </template>
                </Column>
                <Column field="Edited_Date" :header="$t('edited_date')" dataType="date" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <DatePicker dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY"
                            class="p-column-filter p-inputtext-sm" v-if="filterModel" v-model="filterModel.value"
                            @keydown.enter="filterCallback()" 
                            :placeholder="$t('edited_date')"
                            @date-select="filterCallback()" />
                    </template>
                    <template #body="{ data }">
                        {{ this.$formatDateTime(data.Edited_Date) }}
                    </template>
                </Column>
                <Column field="Edited_By" :header="$t('edited_by')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" v-if="filterModel" v-model="filterModel.value"
                            @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"
                            :placeholder="$t('edited_by')" />
                    </template>
                </Column>
                <Column field="Is_Deleted" :header="$t('is_deleted')" dataType="date" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <YNSelect :placeholder="$t('is_deleted')" :useBinary="true" v-if="filterModel"
                            v-model="filterModel.value" @change="filterCallback()" />
                    </template>
                </Column>
                <Column field="Deleted_Date" :header="$t('deleted_date')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <DatePicker dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY"
                            class="p-column-filter p-inputtext-sm" v-if="filterModel" v-model="filterModel.value"
                            @keydown.enter="filterCallback()" @date-select="filterCallback()"
                            :placeholder="$t('deleted_date')" />
                    </template>
                    <template #body="{ data }">
                        {{ this.$formatDateTime(data.Deleted_Date) }}
                    </template>
                </Column>
                <Column field="Deleted_By" :header="$t('deleted_by')" dataType="date" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" v-if="filterModel" v-model="filterModel.value"
                            @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"
                            :placeholder="$t('deleted_by')" />
                    </template>
                </Column>
            </DataTable>
        </template>
    </Card>
</template>

<script>
import IndexBase from '../Helper/IndexBase.vue'
 //import EditorPIC from './_EditorPIC.vue';

export default {
    name: "WoRelease",
    components: {
        'IndexBase': IndexBase,
       // 'EditorPIC': EditorPIC
    },
    data() {
        return {
            dataModel: null,
            loading: true,
            totalRecords: 0,
            start: 0,
            stateKey: this.$STATE_NAME + 'WoRelease-' + this.$store.getters.getUsername,
            isAdmin: this.$store.getters.getIsAdmin,
            sorts: null,
            lazyParams: {},
            filters: null,
            stateFilters: null,
            editorPath: "/WoRelease/Editor",
            editorPICPath: "/WoRelease/EditorPIC",
            dataUrl: "WoRelease/list",
            url: "maindata",
            uploadPath: "/Helper/UploadData/Company",
            canCreate: false,
            canEdit: false,
            canDelete: false,
            canView: false,
            canPrint: false,
            expandedRows: [],
            pageSize : 10,
            isAdminWoPrj : false,
           // editorPICVisible: false,
            selectedWoData: null,
        }
    },
    methods: {
        // showEditorPIC(data) {
        //     this.selectedWoData = data;
        //     this.editorPICVisible = true;
        // },
        isEdit(dataModel){
            let created_by = "";
            let hasPIC = dataModel.data.Has_PIC;
            if(dataModel.data.Created_By){
                created_by = dataModel.data.Created_By.match(/\[(.*?)\]/)[1];
            }
           
            var result = dataModel.data.Is_Deleted == 'N'  && (
                        ((created_by == this.$store.getters.getUsername || hasPIC == 1)
                         // && dataModel.data.Status != this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL
                         && dataModel.data.Status != this.$APPROVAL_STATUS.APPROVED
                         && dataModel.data.Status != this.$APPROVAL_STATUS.REJECTED
                         && dataModel.data.Status != this.$APPROVAL_STATUS.CLOSED) 
                         || (created_by != this.$store.getters.getUsername && (this.isAdminWoPrj || hasPIC == 1) && dataModel.data.Category == this.$CategoryWo.Execution && (dataModel.data.Status != this.$APPROVAL_STATUS.APPROVED
                         && dataModel.data.Status != this.$APPROVAL_STATUS.REJECTED
                         && dataModel.data.Status != this.$APPROVAL_STATUS.CLOSED )));
            return result;

        },
        isDelete(dataModel){
            let created_by = "";
            if(dataModel.data.Created_By){
                created_by = dataModel.data.Created_By.match(/\[(.*?)\]/)[1];
            }

            var result = dataModel.data.Is_Deleted == 'N'  && ((created_by == this.$store.getters.getUsername
                         &&  dataModel.data.Status != this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL 
                         && dataModel.data.Status != this.$APPROVAL_STATUS.APPROVED 
                         && dataModel.data.Status != this.$APPROVAL_STATUS.REJECTED 
                         && dataModel.data.Status != this.$APPROVAL_STATUS.CLOSED) || (created_by != this.$store.getters.getUsername && this.isAdminWoPrj && dataModel.data.Category == this.$CategoryWo.Execution && dataModel.data.Status == this.$APPROVAL_STATUS.FULL_RELEASE ));

            return result;

        },
        downloadPrint(type){
                this.$emit('block-ui');
                var self = this;

                self.lazyParams = {
                    start: this.start,
                    sorts: this.dataSort,
                    filters: this.dataFilter,
                    from_date : this.From_Date,
                    to_date : this.to_date,
                    type : type
                };
               
                this.$axios.post(this.$API_URL + "WoRelease/" + "downloadprint",self.lazyParams,{
                    responseType: 'blob',
                    timeout: this.$AXIOS_TIMEOUT_LONG
                })
                .then((response) => {
                    if(type == "PDF"){
                        const blob = new Blob([response.data], { type: 'application/pdf' });
                        const url = URL.createObjectURL(blob);
                        window.open(url, '_blank');
                    }
                    else{
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        let fileName = response.headers["content-disposition"].split("filename=")[1].split(";")[0];
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', fileName);
                        document.body.appendChild(link);
                        link.click();
                    }   
                })
                .catch(function (err) {
                    const errorMsg = err.isTimeout ? err.message : "File not found: " + err.message;
                    self.$toast.add({ severity: 'error', summary: "Error", detail: errorMsg, life: 10000});
                })
                .finally(() => {
                    self.$emit('unblock-ui');
                });
        },
        rowClass(data) {
            return [
                    
                    //{ 'bg-red': data.Is_Deleted == 'Y' },
                ];
        },
        generatePdf(model){
            this.$emit('block-ui');
            var self = this;
            model.valueLink = this.$store.getters.getUrlApp + this.$route.fullPath;
            model.signby = `${this.$DOCUMENTFOOTER.APPROVED_GENERATED} (Document Print by ${this.$store.getters.getFullname} at ${this.$formatDateTime2(new Date())})`;
            
            this.$axios.post(this.$API_URL + "WoRelease/" + "downloadprint", model,{
                responseType: 'blob',
                timeout: this.$AXIOS_TIMEOUT_LONG
            })
            .then((response) => {
                const blob = new Blob([response.data], { type: 'application/pdf' });
                const url = URL.createObjectURL(blob);
                window.open(url, '_blank');
            })
            .catch(function (err) {
                const errorMsg = err.isTimeout ? err.message : "File not found: " + err.message;
                self.$toast.add({ severity: 'error', summary: "Error", detail: errorMsg, life: 10000});
            })
            .finally(() => {
                self.$emit('unblock-ui');
            });
        },  
        onAuth(event) {
            this.canCreate = event.canCreate;
            this.canEdit = event.canEdit;
            this.canDelete = event.canDelete;
            this.canView = event.canView;
            this.canPrint = event.canPrint;
        },
        onPage(event) {
            this.start = event.first;
            this.pageSize = event.rows;
            this.loadLazyData();
        },
        onSort(event) {
            this.sorts = event.multiSortMeta;
            this.loadLazyData();
        },
        onFilter() {
            this.loadLazyData();
        },
        onSelect(event) {
            this.selectedRow = event.data;
        },
        onRowExpand(event) {
            this.expandedRows = [];
            this.expandedRows.push(event.data);
        },
        editor(mode,id) {
            this.$router.push({ path: "/WoRelease/Editor", query: { mode: mode, id: id } });
        },
        editorPIC(mode,id) {
            this.$router.push({ path: "/WoRelease/EditorPIC", query: { mode: this.$FORM_MODE_EDIT_PIC , id: id } });
        },
        filter(mode) {
            this.$router.push({ path: this.filterPath, query: { mode: mode } });
        },
        sidebarMessage(event) {
            this.$toast.add(event);
        },
        loadLazyData() {
            this.loading = true;
            this.selectedRow = null;

            this.lazyParams = {
                start: this.start,
                pageSize : this.pageSize,
                sorts: this.dataSort,
                filters: this.dataFilter
            };

            var self = this;

            this.$axios.post(this.$API_URL + this.dataUrl, this.lazyParams)
                .then((response) => {
                    if (response.data.success) {
                        this.dataModel = response.data.data;
                        this.totalRecords = response.data.totalRecords;
                    }
                    else {
                        self.$toast.add({ severity: 'error', summary: "Error", detail: response.data.message, life: this.$DEFAULT_TIMER });
                    }
                })
                .catch(function (err) {
                    const errorMsg = err.isTimeout ? err.message : err.message;
                    self.$toast.add({ severity: 'error', summary: "Error", detail: errorMsg, life: self.$DEFAULT_TIMER });
                })
                .finally(() => {
                    self.loading = false;
                });
        },
        setFilters() {
            this.filters = {};
            var exportable = this.$refs.dt.columns.filter(c => c.props.field);
            for (var i = 0; i < exportable.length; i++) {
                var filterValue = null;
                if (this.stateFilters) {
                    var field = this.stateFilters[exportable[i].props.field];
                    if (field) filterValue = field.value;
                }
                this.filters[exportable[i].props.field] = { value: filterValue, matchMode: "contains" };
            }
        },
        onStateRestore(event) {
            this.start = event.first;
            this.pageSize = event.rows;
            this.stateFilters = event.filters;
            this.sorts = event.multiSortMeta;
        },
        onModalClose() {
            this.loadLazyData();
        },
        clearFilter() {
            this.filters = {};
            var exportable = this.$refs.dt.columns.filter(c => c.props.field);
            for (var i = 0; i < exportable.length; i++) {
                var fieldName = exportable[i].props.field;
                var filterValue = "";
                if (fieldName.includes("Date")) {
                    filterValue = null;
                }
                this.filters[exportable[i].props.field] = { value: filterValue, matchMode: "contains" };
            }
            this.loadLazyData();
        },
        importFile() {
            this.$router.push({ path: this.uploadPath });
        },
    },
    mounted() {
        this.$emit('unblock-ui');
        this.setFilters();
        this.loadLazyData();
        this.$showToast();
        if(this.$store.getters.getJobPosition)
            this.isAdminWoPrj = this.$store.getters.getJobPosition.includes(this.$UserLevel.ADMIN_WO_PROJECT);
    },
    computed: {
        dataFilter() {
            var h = [];
            if (this.filters) {
                for (const [key, value] of Object.entries(this.filters)) {
                    h.push({
                        field: key ? key : null,
                        value: value.value,
                        matchMode: value.matchMode
                    });
                }
            }
            return h;
        },
        dataSort() {
            var h = [];
            if (this.sorts) {
                for (var x = 0; x < this.sorts.length; x++) {
                    h.push({
                        field: this.sorts[x].field,
                        order: this.sorts[x].order == 1 ? "ASC" : "DESC"
                    });
                }
            }
            return h;
        },
        filterBadge() {
            var badgeNumber = 0;

            this.dataFilter.filter(function (item) {
                if (item.value) {
                    badgeNumber++;
                }
            });

            return badgeNumber;
        }
    },
}
</script>
<style>
    #main .bg-red{
        background-color:rgb(233, 103, 103);
    }
</style>
<style #scoped>
.p-card .p-card-content {
    margin: 0 !important;
    padding: 0 !important;
}
</style>